import React from 'react';
import style from './small.input.less';
import FormComponent from '../FormComponent.jsx';
import classNames from 'classnames';
import TextInput from '../text.input/text.input.jsx';
import { compareObjectsInclusive } from '../../../common/utils.jsx';

export default class SmallInput extends FormComponent {
    constructor() {
        super();
        this.onChangePreprocessor = this.onChangePreprocessor.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        return compareObjectsInclusive(this.props, nextProps, [ 'value', 'disabled', 'name', 'placeholder', 'unit', 'error', 'length' ]);
    }
    onChangePreprocessor(name, value) {
        this.onChangeHandler(value);
    }
    render() {
        const { value, title, unit, name, error, length, disabled, onlyNumbers } = this.props;
        let label;
        if (title) {
            label = <h5 className={style.label}>{title}</h5>;
        } else {
            label = <h5 className={style.label} dangerouslySetInnerHTML={{ __html: '&nbsp;' }}></h5>;
        }
        const cssClass = classNames(style.input, { [style.error]: error });
        return (
            <div className={style.inputWrapper}>
                {label}
                <TextInput onlyNumbers={onlyNumbers} disabled={disabled} cssWrapperClass={style.textInput} length={length} cssClass={cssClass} value={value} name={name} onChangeCallback={this.onChangePreprocessor}/>
                <span className={style.unit}>{unit}</span>
            </div>
        );
    }
}
